module.exports = __webpack_public_path__ + "img/1.20210923SCAD_Mobile_04.796a2f59.jpg";